import React, { useRef, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { GoAlert } from 'react-icons/go';
import { Button } from 'primereact/button';
import midiaServices from '../../../../services/tvs/midiaServices';
import { acoes } from '../helpers/objetosAuxiliares';
import { Growl } from 'primereact/growl';
import { mostrarMensagemSucesso, mostrarMensagemErro } from '../../shared/getMensagens';
import { ProgressSpinner } from 'primereact/progressspinner';

export function ExcluirRegistro({
    rowSelecionada,
    modalAberto,
    setModalAberto,
    setRecarregarDataTable
}) {
    const [loand, setLoand] = useState(false);
    const mensagemToast = useRef(null);

    const fecharModal = () => setModalAberto(false);

    const inativarParametro = async dadosSelecionados => {
        const { path , Id_doc } = dadosSelecionados;

        try {
            setLoand(true);
            await midiaServices.deleteMidia(path, Id_doc);
            fecharModal();
            setRecarregarDataTable(true);
            setRecarregarDataTable(false);
            setLoand(false);
            
            mostrarMensagemSucesso(mensagemToast,'Arquivo excluido com sucesso!' );
        } catch (error) {
            setLoand(false);
            fecharModal();
            error.response.data.mensagem.includes('SequelizeForeignKeyConstraintError') ?
                mostrarMensagemErro(mensagemToast,
                    'Arquivo esta vinculado a um grupo'):     
                mostrarMensagemErro(mensagemToast,
                    'Não foi possível excluir o arquivo, erro na internet!');
            throw new Error();
        }
    };

    const body = (
        <div
            style={{
                display: 'flex',
                gap: '8px',
                flex: '1',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <GoAlert size={80} color="black" />
            <h2>{acoes[rowSelecionada.Status]} Deseja excluir esse arquivo?</h2>
        </div>
    );

    const footer = (
        <div style={{ display: 'flex',
            gap: '8px',
            alignItems: 'center' }}>
            <p>Tem certeza que deseja fazer isso?</p>
            <Button
                className="p-button-success"
                label="Sim"
                onClick={() => inativarParametro(rowSelecionada)}
            />
            <Button className="p-button-danger" label="Não" onClick={fecharModal} />
        </div>
    );

    return (
        <>
            <Growl ref={mensagemToast} />
            
            <Dialog
                dismissableMask
                visible={modalAberto}
                showHeader={false}
                onHide={fecharModal}
                footer={footer}
                position="bottom"
            >
                {loand ? <div className="p-col size-spinner">  <ProgressSpinner /></div>  : 
                    body 
                }
            </Dialog>
        </>
    );
}
